var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEventLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 35,
    viewBox: "0 0 34 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 35,
    fill: "#E8E4E4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rosters > Overview",
    clipPath: "url(#clip0_847_14812)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1245,
    transform: "translate(-302 -262)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 4677"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Incident header"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 4674"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 327",
    x: -24,
    y: -24,
    width: 1136,
    height: 91,
    rx: 5,
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 4797"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 4260"
  }, /*#__PURE__*/React.createElement("g", {
    id: "111088_electricity_icon 2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34.3707,
    rx: 17,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3973 14.5739L19.9937 8.72837C20.0174 8.65657 20.0294 8.58025 20.0294 8.50106C20.0294 8.0879 19.6801 7.75031 19.2469 7.75031C19.0011 7.75031 18.7824 7.85645 18.6396 8.02723L10.6705 17.8945C10.5635 18.0234 10.5 18.1866 10.5 18.3647C10.5 18.7816 10.8574 19.123 11.2941 19.123H16.1022L14.5063 24.9685C14.4822 25.0407 14.4705 25.1166 14.4705 25.1958C14.4705 25.6094 14.82 25.9466 15.2527 25.9466C15.4989 25.9466 15.7172 25.8407 15.8602 25.6696L23.829 15.8022C23.9364 15.6734 24 15.5105 24 15.3321C24 14.9152 23.6424 14.5739 23.206 14.5739H18.3973Z",
    fill: "black"
  }))))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_847_14812"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1245,
    fill: "white",
    transform: "translate(-302 -262)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventLight);
export default __webpack_public_path__ + "static/media/eventLight.fecf5bd352f4bf687277bff092a8b955.svg";
export { ForwardRef as ReactComponent };